import { useLanguage } from '../context/LanguageContext';
import { PackageCheck, ShieldCheck, UserRoundCheck, BadgeCheck } from 'lucide-react';

export default function TrustGuarantees() {
  const { t, isRomanian } = useLanguage();

  const guarantees = [
    {
      icon: PackageCheck,
      title: t('trust_g1_title'),
      desc: t('trust_g1_desc'),
      accent: 'bg-brand-orange',
      accentLight: 'bg-brand-orange/10',
      badge: isRomanian ? 'Comunitate activă' : 'Active community',
    },
    {
      icon: ShieldCheck,
      title: t('trust_g2_title'),
      desc: t('trust_g2_desc'),
      accent: 'bg-brand-success',
      accentLight: 'bg-brand-success/10',
      badge: t('trust_money_back'),
    },
    {
      icon: UserRoundCheck,
      title: t('trust_g3_title'),
      desc: t('trust_g3_desc'),
      accent: 'bg-brand-brown',
      accentLight: 'bg-brand-brown/10',
      badge: t('trust_no_lock'),
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-white relative overflow-hidden" data-testid="trust-guarantees">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-orange/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-brand-success/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" />

      <div className="section-container relative">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-success/10 text-brand-success rounded-full text-sm font-semibold mb-4">
            <BadgeCheck className="w-4 h-4" />
            {isRomanian ? 'Garanții verificate' : 'Verified guarantees'}
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-brown mt-2">
            {t('trust_guarantee_title')}
          </h2>
        </div>

        {/* Guarantee Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {guarantees.map((item, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-3xl border-2 border-brand-border/60 p-7 lg:p-8 hover:border-brand-orange/40 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              data-testid={`trust-guarantee-${i}`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 ${item.accent} rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <item.icon className="w-7 h-7 text-white" />
              </div>

              {/* Title */}
              <h3 className="font-heading text-xl font-bold text-brand-brown mb-3">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-brand-muted text-sm leading-relaxed mb-5">
                {item.desc}
              </p>

              {/* Badge */}
              <div className={`inline-flex items-center gap-2 ${item.accentLight} px-3 py-1.5 rounded-full`}>
                <BadgeCheck className="w-3.5 h-3.5 text-brand-success" />
                <span className="text-xs font-semibold text-brand-brown">{item.badge}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
